module.exports = __webpack_public_path__ + "static/media/knauf-johns-manville-insulation.fda0aaf0.webp";